import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyDnw3ZApzMHOrbpa13I0xfnRiibKCgjQ-I',
  authDomain: 'friendsquads.firebaseapp.com',
  databaseURL: 'https://friendsquads-default-rtdb.firebaseio.com',
  projectId: 'friendsquads',
  storageBucket: 'friendsquads.appspot.com',
  messagingSenderId: '354269832551',
  appId: '1:354269832551:web:104659120c307017fefbc2',
  measurementId: 'G-GM16XN3FZM'
}
firebase.initializeApp(firebaseConfig)
const auth = firebase.auth()
const db = firebase.firestore()
db.settings({ timestampsInSnapshots: true })

export { auth, db }
